"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalDocumentDtoKindEnum = void 0;
exports.instanceOfLegalDocumentDto = instanceOfLegalDocumentDto;
exports.LegalDocumentDtoFromJSON = LegalDocumentDtoFromJSON;
exports.LegalDocumentDtoFromJSONTyped = LegalDocumentDtoFromJSONTyped;
exports.LegalDocumentDtoToJSON = LegalDocumentDtoToJSON;
exports.LegalDocumentDtoToJSONTyped = LegalDocumentDtoToJSONTyped;
var LegalSectionDto_1 = require("./LegalSectionDto");
/**
 * @export
 */
exports.LegalDocumentDtoKindEnum = {
    Terms: 'terms',
    Privacy: 'privacy'
};
/**
 * Check if a given object implements the LegalDocumentDto interface.
 */
function instanceOfLegalDocumentDto(value) {
    if (!('kind' in value) || value['kind'] === undefined)
        return false;
    if (!('version' in value) || value['version'] === undefined)
        return false;
    if (!('effectiveDate' in value) || value['effectiveDate'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('intro' in value) || value['intro'] === undefined)
        return false;
    if (!('sections' in value) || value['sections'] === undefined)
        return false;
    if (!('language' in value) || value['language'] === undefined)
        return false;
    return true;
}
function LegalDocumentDtoFromJSON(json) {
    return LegalDocumentDtoFromJSONTyped(json, false);
}
function LegalDocumentDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'kind': json['kind'],
        'version': json['version'],
        'effectiveDate': json['effectiveDate'],
        'title': json['title'],
        'intro': json['intro'],
        'sections': (json['sections'].map(LegalSectionDto_1.LegalSectionDtoFromJSON)),
        'language': json['language'],
    };
}
function LegalDocumentDtoToJSON(json) {
    return LegalDocumentDtoToJSONTyped(json, false);
}
function LegalDocumentDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'kind': value['kind'],
        'version': value['version'],
        'effectiveDate': value['effectiveDate'],
        'title': value['title'],
        'intro': value['intro'],
        'sections': (value['sections'].map(LegalSectionDto_1.LegalSectionDtoToJSON)),
        'language': value['language'],
    };
}
